import React from 'react';
import { Select } from 'antd';
import { useQuery } from '@apollo/client';
import { GET_HUB_LIST, GetHubListResponse } from '../../pages/wms/bags/graphql/queries/getHubList';
import { useFilterLabelClassName, useFilterContainerClassName, useFilterInputContainerClassName } from '../../utils/languageUtils';

interface PrePickupHubSelectFilterProps {
  label: string;
  /** 预拣揽收中心名称（后端按名称精确匹配） */
  value?: string;
  onChange: (value: string | undefined) => void;
  spanClassName?: string;
  placeholder?: string;
  className?: string;
}

/**
 * 预计揽收中心选择过滤器组件
 */
export const PrePickupHubSelectFilter: React.FC<PrePickupHubSelectFilterProps> = ({
  label,
  value,
  onChange,
  spanClassName,
  placeholder = 'Select HUB',
  className
}) => {
  const { data, loading } = useQuery<GetHubListResponse>(GET_HUB_LIST);

  // 构建下拉选项
  const hubOptions = React.useMemo(() => {
    if (!data?.hubList) return [];

    return data.hubList
      .filter(hub => hub.sortingCode) // 过滤掉没有sortingCode的hub
      .map(hub => {
        const firstSegment = hub.sortingCode?.split('-')[0] || '';
        return {
          label: `${hub.name} (${firstSegment})`,
          // 这里使用 name 作为 value，方便直接写入 prePickupHubName 做名称精确匹配
          value: hub.name,
          code: firstSegment,
          // 用于搜索的文本，包含名称、代码和ID
          searchText: `${hub.name} ${firstSegment} ${hub.sortingCode} ${hub.id}`
        };
      })
      .filter(opt => opt.value); // 过滤空值
  }, [data]);

  const containerClassName = useFilterContainerClassName(className);
  const labelClassName = useFilterLabelClassName(spanClassName);
  const inputContainerClassName = useFilterInputContainerClassName();

  return (
    <div className={containerClassName}>
      <span className={labelClassName}>{label}</span>
      <div className={inputContainerClassName}>
        <Select
          showSearch
          allowClear
          placeholder={placeholder}
          value={value}
          onChange={(val) => {
            const nextVal = (val as string) || undefined;
            onChange(nextVal);
          }}
          loading={loading}
          options={hubOptions}
          filterOption={(input, option) => {
            const searchText = (option as any)?.searchText || '';
            return searchText.toLowerCase().includes(input.toLowerCase());
          }}
          className="w-full"
          size="middle"
        />
      </div>
    </div>
  );
};

export default PrePickupHubSelectFilter;

